import getFetchOptions from '../utils/getFetchOptions';

import {ENDPOINT_URL} from '../constants';

export default function submitTestUserInfo(testUser) {
	return fetch(
		`${ENDPOINT_URL}/test/infocustom`,
		getFetchOptions({
			method: 'PATCH',
			body: JSON.stringify(testUser),
		})
	);
}
